import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import 'firebase/compat/analytics'
import 'firebase/compat/storage'
import 'firebase/compat/functions'
import 'firebase/compat/messaging'

var firebaseConfig = {
  apiKey: 'AIzaSyC6Swg9H5SoioL2ixvT5mgmM9P0blsmUuI',
  authDomain: 'rbo-system.firebaseapp.com',
  databaseURL: 'https://rbo-system.firebaseio.com',
  projectId: 'rbo-system',
  storageBucket: 'rbo-system.appspot.com',
  messagingSenderId: '461253343272',
  appId: '1:461253343272:web:492f4de37341567b',
  measurementId: 'G-VTNQX0EQ1X'
}

firebase.initializeApp(firebaseConfig)

export default firebase


//////////////////
// WEBPACK FOOTER
// ./firebase.js
// module id = 207
// module chunks = 15